module.exports = __webpack_public_path__ + "static/demolition-contractors-a33eeed55f61368415ca52c7f3a13bb3.jpg";